<script setup>
import { computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@provise/stores/user'
import { useApi } from '@provise/composables/api'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const { user } = storeToRefs(userStore)

const query = computed(() => {
  const query = route.query
  return {
    service: query.service,
    token: query.token,
  }
})

const { model: ssoResponse, refresh: ssoLoginApi } = useApi({
  url: '/web/autologin',
  query: query,
  watch: [query],
  method: 'post',
})

onMounted(async () => {
  if (!query.value.token) {
    router.push({ name: 'sso_login' })
    return
  }

  await ssoLoginApi()
  if (!ssoResponse.value?.access_token) {
    return
  }

  user.value = {
    ...user.value,
    username: ssoResponse.value.username,
    access_token: ssoResponse.value.access_token,
  }
  router.push({ name: 'home' })
})
</script>
<template></template>
